import {
  formatCurrency,
  IFormatCurrecyOptions,
} from 'utils/global/currency.utils';

// export const getMaxFormattedLength = (getter: (e: (typeof tableData.nodes)[0]) => number) => {
//     const maxNumber = tableData?.nodes
//       ?.map(e => getter(e) ?? 0)
//       .reduce((max, num) => (num.toString().length > max.toString().length ? num : max), 0);

//     return formatCurrency(maxNumber).length;
//   };

export const getMaxFormattedLength = <T>(
  data: T[],
  getter: (e: T) => number | undefined,
  options?: IFormatCurrecyOptions
) => {
  const maxNumber = data
    ?.map(e => getter(e) ?? 0)
    .reduce(
      (max, num) => (num.toString().length > max.toString().length ? num : max),
      0
    );

  return formatCurrency(maxNumber, options).length;
};
